import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var CloudUpload = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "cloud-upload"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9 12c0-.11-.06-.22-.09-.33a4.17 4.17 0 00-.18-.57c-.05-.12-.12-.24-.18-.37s-.15-.3-.24-.44S21 10.08 21 10s-.2-.25-.31-.37-.21-.2-.32-.3L20 9l-.36-.24a3.68 3.68 0 00-.44-.23l-.39-.18a4.13 4.13 0 00-.5-.15 3 3 0 00-.41-.09L17.67 8A6 6 0 006.33 8l-.18.05a3 3 0 00-.41.09 4.13 4.13 0 00-.5.15l-.39.18a3.68 3.68 0 00-.44.23l-.36.3-.37.31c-.11.1-.22.19-.32.3s-.21.25-.31.37-.18.23-.26.36-.16.29-.24.44-.13.25-.18.37a4.17 4.17 0 00-.18.57c0 .11-.07.22-.09.33A5.23 5.23 0 002 13a5.5 5.5 0 00.09.91c0 .1.05.19.07.29a5.58 5.58 0 00.18.58l.12.29a5 5 0 00.3.56l.14.22a.56.56 0 00.05.08L3 16a5 5 0 004 2h3v-1.37a2 2 0 01-1 .27 2.05 2.05 0 01-1.44-.61 2 2 0 01.05-2.83l3-2.9A2 2 0 0112 10a2 2 0 011.41.59l3 3a2 2 0 010 2.82A2 2 0 0115 17a1.92 1.92 0 01-1-.27V18h3a5 5 0 004-2l.05-.05a.56.56 0 00.05-.08l.14-.22a5 5 0 00.3-.56l.12-.29a5.58 5.58 0 00.18-.58c0-.1.05-.19.07-.29A5.5 5.5 0 0022 13a5.23 5.23 0 00-.1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.71 11.29a1 1 0 00-1.4 0l-3 2.9a1 1 0 101.38 1.44L11 14.36V20a1 1 0 002 0v-5.59l1.29 1.3a1 1 0 001.42 0 1 1 0 000-1.42z"
  }))));
});
CloudUpload.displayName = 'CloudUpload';
export var CloudUploadDimensions = {
  height: 24,
  width: 24
};